export const forgotPassword = () => {
  return {
    title: 'Forgot Password',
    subtitle_1: 'Please enter your email address to reset your password.',
    email: 'Enter email address',
    send: 'Submit',
    back_to_log_in: 'Back to Sign In',
    email_not_found: 'The email entered is invalid, please try again.',
    email_sent: {
      title: 'Reset Password Sent!',
      subtitle_1: 'A reset password email has been sent. Please check your spam/junk folder if you’re not receiving \n emails from the MyWork Enterprise.',
      log_in: 'Log In'
    }
  }
}
